import { render, staticRenderFns } from "./NCCodesForm.vue?vue&type=template&id=123e2b7a&"
import script from "./NCCodesForm.vue?vue&type=script&lang=js&"
export * from "./NCCodesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports